import React from 'react';
import { MdHome } from 'react-icons/md';

import './styles.css';

const Breadcrumb: React.FC = () => (
  <div className='mh-breadcrumb'>
    <MdHome size={21} color='#757575' />
  </div>
);

export default Breadcrumb;
